import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { DropdownToggle, DropdownMenu, Dropdown } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import { useQuery, useLazyQuery, useMutation } from '@apollo/react-hooks';
import { NO_LEIDOS, MIS_AVISOS } from '../../graphql/queries/avisos';
import { MARCAR_AVISO_LEIDO, MARCAR_TODOS_AVISOS_LEIDOS } from '../../graphql/mutations/avisos';
import CustomizableModal from '../Common/Modal/CustomizableModal';
import DetalleFactorIntegracion from '../Catalogos/FactorIntegracion/Detalle';
import { ddmmyyyy } from '../../pipes';

// El contador se refresca cada 5 minutos; la lista se pide al abrir la campana. El backend decide qué avisos ve cada
// usuario (AlcanceUsuario, con el usuario del token), así que aquí no se filtra nada.
const CINCO_MINUTOS = 5 * 60 * 1000;
const TAMANO_PAGINA = 10;
const TIPO_FACTOR_INTEGRACION = 'FACTOR_INTEGRACION_ACTUALIZADO';

export const textoContador = (cantidad) => (cantidad > 99 ? '99+' : String(cantidad));

const CampanaAvisos = ({ t }) => {
  const [abierto, setAbierto] = useState(false);
  // Aviso cuyo detalle está abierto en el modal de avisos.
  const [avisoAbierto, setAvisoAbierto] = useState(null);
  const [errorAccion, setErrorAccion] = useState(null);

  const { data: datosContador, refetch: refetchContador } = useQuery(NO_LEIDOS, {
    pollInterval: CINCO_MINUTOS,
    fetchPolicy: 'network-only'
  });
  const [cargarAvisos, { data, loading, error, refetch: refetchAvisos }] = useLazyQuery(MIS_AVISOS, {
    fetchPolicy: 'network-only',
    variables: { query: { pagina: 0, tamanoPagina: TAMANO_PAGINA, busqueda: '' }, soloNoLeidos: false }
  });
  const [marcarLeido] = useMutation(MARCAR_AVISO_LEIDO);
  const [marcarTodos] = useMutation(MARCAR_TODOS_AVISOS_LEIDOS);

  const noLeidos = (datosContador && datosContador.avisos && datosContador.avisos.noLeidos) || 0;
  const avisos =
    (data && data.avisos && data.avisos.misAvisos && data.avisos.misAvisos.items) || [];

  const recargar = () => {
    refetchContador();
    if (refetchAvisos) refetchAvisos();
  };

  const toggle = () => {
    const abrir = !abierto;
    setAbierto(abrir);
    setErrorAccion(null);
    if (abrir) {
      if (refetchAvisos) refetchAvisos();
      else cargarAvisos();
    }
  };

  const abrirAviso = (aviso) => {
    setAbierto(false);

    if (!aviso.leido) {
      marcarLeido({ variables: { avisoId: aviso.id } })
        .then(recargar)
        .catch(() => setErrorAccion(t('errors.MARCAR_LEIDO')));
    }

    if (aviso.tipo === TIPO_FACTOR_INTEGRACION && aviso.referenciaId) setAvisoAbierto(aviso);
  };

  const marcarTodosLeidos = () => {
    marcarTodos()
      .then(recargar)
      .catch(() => setErrorAccion(t('errors.MARCAR_TODOS_LEIDOS')));
  };

  const contenido = () => {
    if (loading) return <div className='campanaVacio'>{t('CARGANDO')}</div>;
    if (error) return <div className='campanaVacio text-danger'>{t('errors.CARGAR')}</div>;
    if (avisos.length === 0) return <div className='campanaVacio'>{t('SIN_AVISOS')}</div>;

    return avisos.map((aviso) => (
      <div
        key={aviso.id}
        className={`campanaAviso${aviso.leido ? '' : ' noLeido'}`}
        role='button'
        tabIndex={0}
        onClick={() => abrirAviso(aviso)}
        onKeyPress={(e) => {
          if (e.key === 'Enter') abrirAviso(aviso);
        }}
      >
        {aviso.titulo}
        <small>{aviso.mensaje}</small>
        <small>{ddmmyyyy(aviso.fechaCreacion)}</small>
      </div>
    ));
  };

  return (
    <>
      <Dropdown isOpen={abierto} direction='left' toggle={toggle} className='campanaAvisos'>
        <DropdownToggle nav className='dropdown-toggle-nocaret dropdown--hover' title={t('TOOLTIP')}>
          <i className='fas fa-bell campanaIcono' />
          {noLeidos > 0 && <span className='campanaContador'>{textoContador(noLeidos)}</span>}
        </DropdownToggle>

        <DropdownMenu
          className='dropdown-menu-right right container_info_profile custom-dropdown-menu campanaMenu'
          style={{ top: 'auto' }}
        >
          <div className='campanaEncabezado'>
            <strong>{t('TITULO')}</strong>
            {noLeidos > 0 && (
              <button type='button' className='btn btn-link campanaMarcarTodos' onClick={marcarTodosLeidos}>
                {t('buttons.MARCAR_TODOS_LEIDOS')}
              </button>
            )}
          </div>
          <div className='dropdown-divider' />
          {errorAccion && <div className='campanaVacio text-danger'>{errorAccion}</div>}
          {contenido()}
        </DropdownMenu>
      </Dropdown>

      {avisoAbierto && (
        <CustomizableModal
          width='80%'
          tittle={avisoAbierto.titulo}
          icono='fas fa-info-circle'
          subTitulo=''
          setModal={() => setAvisoAbierto(null)}
          modal={true}
        >
          <p>{avisoAbierto.mensaje}</p>
          <DetalleFactorIntegracion procesoId={avisoAbierto.referenciaId} />
        </CustomizableModal>
      )}
    </>
  );
};

CampanaAvisos.propTypes = {
  t: PropTypes.func
};

export default withTranslation('avisos')(CampanaAvisos);
